import { equals } from "@arcgis/core/geometry/geometryEngine";

/**
 * Wrapper class around __esri.Graphic to store additional information (e.g. residential layer, id, etc.)
 */
export class Graphic {
    layerName: string;
    labelLayerName: string;
    graphic:  __esri.Graphic;


    constructor(layerName: string, graphic: __esri.Graphic) {
        this.layerName = layerName;
        this.labelLayerName = layerName + "_text";
        this.graphic = graphic;
    }

    /**
     * Check equality of two graphic objects by uuid.
     *
     * @param other The other Graphic object
     */
    equals(other: Graphic): boolean {
        return this.layerName === other.layerName && equals(this.graphic.geometry, other.graphic.geometry);
    }

    /**
     * Return the esri Graphic object as JSON string
     */
    toJSON(): string {
        return this.graphic.toJSON();
    }
}
